export const getTranslatedPropertyFromContext = (item, property, config) => {
    const { language, isActiveFeature } = config;

    if (!isActiveFeature('PLT-13627_language_context_in_navigation') || !item.languageContext?.[language]?.[property]) {
        return item[property];
    }

    return item.languageContext[language][property];
};
